



import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class SubTitle extends Vue {
  @Prop({ default: 'Subtitle' }) text!: string
}
